import { memo, useEffect, useRef } from "react"
import { access, logTimestamp, useEvent, useProperty } from "../../support/general"
import { makeUniversalBlockKey, modelStore, selectionStore } from "../storage/model"
import $ from "jquery"
import { Cell, MetaCell, TableColumn } from "./Column";
import { getFieldDef, makeFieldCell } from "./Fields";
import { PlusMinus } from "../../support/UxBitsAndPieces";

export function NavIdentifier({scriptId,subscriptId,column,indented,isOccupied,block,onClick,navUnit,onPlusMinusClicked}){

    // const refEle = useRef();
    const [getIsOver,setIsOver] = useProperty(false);
    // useEffect(()=>{
    //     $(refEle.current).on('mouseover',()=>setIsOver(true));
    //     $(refEle.current).on('mouseleave',()=>setIsOver(false));
    // },[])
    return (<Cell
        scriptId = {scriptId}
        subscriptId = {subscriptId}
        col = {column}
        indented = {indented}
        key = {column.fieldId}
        onClick = {onClick}
        // ref = {refEle}
        onMouseOver = {()=>setIsOver(true)}
        onMouseLeave = {()=>setIsOver(false)}
        style = {{
            overflowX : 'hidden',
            textWrap : 'nowrap',
            backgroundColor : isOccupied?'#E0FFE0':'white',
            // minHeight : "2em",
            overflowY : 'hidden'

        }}
    >
        <PlusMinus 
            isVisible = {!! navUnit.subUnits.length && getIsOver()}
            isOpen = {!!navUnit.isOpen}
            onClick = {()=>{
                onPlusMinusClicked(navUnit.index)
            }}
        />
        <span
            style={{marginLeft:(indented + 0.5)+'em'}}
        >{block.text}</span>
    </Cell>)
}

export function NavCharacterCell({scriptId,subscriptId,column,block,navUnit,levelShowing}){

    var fieldId = column.fieldId;

    var name = fieldId.substring(1);
    var containsName = "";
    if (navUnit.level == levelShowing){
        containsName =  !!access(block,["info","characters",name]);
    }
    return (<Cell
        scriptId = {scriptId}
        subscriptId = {subscriptId}
        col = {column}
        key = {column.fieldId}
        style = {{
            overflow : 'hidden',
            textWrap : 'nowrap',
            textAlign : 'center',
        }}
    >
        {containsName?"yes":""}
    </Cell>)
}
export const NavigationRow = memo(function ({scriptId,subscriptId,isOccupied,navUnit,onSelectedNavigationChanged,onPlusMinusClicked,levelShowing}){

    // logTimestamp("run NavigationRow");

    modelStore.useSelector(state=>{
        return access (state,["model","Script",scriptId,"subscripts",subscriptId,"columns"]);
    },navUnit.headBlockUid);

    var columns = access (modelStore.state,["model","Script",scriptId,"subscripts",subscriptId,"columns"]);
    columns = columns?columns:[];

    var block = modelStore.useSelector(state=>{
            var block =  access(state,["model","Block",navUnit.headBlockUid]);
            return block;
    })

    var cells = [];
    var totalWidth = 0;
    var text = ""
    if (block && columns){

        $.each(columns,(c,col)=>{
            var eventHandlers = {}
            totalWidth += col.width;
            var field = getFieldDef(modelStore.state,col.fieldId,subscriptId);
            if (field.clickStyle == 'documentNavigation'){
                var blockId = block.id;
                eventHandlers.onClick = ()=>{
                    onSelectedNavigationChanged(blockId);
                }
            }
            if (field.type=='navIdentifier'){
                cells.push(<NavIdentifier
                    scriptId = {scriptId}
                    subscriptId = {subscriptId}
                    column = {col}
                    indented = {navUnit.level}
                    isOccupied = {isOccupied}
                    block = {block}
                    onClick = {()=>{onSelectedNavigationChanged(blockId)}}
                    onPlusMinusClicked = {onPlusMinusClicked}
                    navUnit = {navUnit}
                />);
            } else if (field.type=='characterCell'){
                cells.push(<NavCharacterCell
                    scriptId = {scriptId}
                    subscriptId = {subscriptId}
                    column = {col}
                    block = {block}
                    navUnit = {navUnit}
                    levelShowing = {levelShowing}
                />);
            } else {
                cells.push(
                    makeFieldCell(col,scriptId,subscriptId,field.type,block,navUnit.level,c,eventHandlers,isOccupied,navUnit)
                )
            }
        })
    }

    return (<div
        id = "NavigationRow"
        className="p-0 m-0"
        style={{
            textAlign:'left',
            padding : '0px',
            width : totalWidth+"px",           
        }}
    >
        {cells}
    </div>);

});

export function Navigation({scriptId,subscriptId,style,className,occupiedNavUnitIndex,onSelectedNavigationChanged}){

    logTimestamp("run Navigation : "+subscriptId);

    modelStore.useSelector(state=>{
        // logTimestamp("navigation selector");
        return access(state,["model","Script",scriptId,"subscripts",subscriptId,"navList"]);
    } , "nav" ,subscriptId )

    var navUnits = access(modelStore.state,["model","Script",scriptId,"subscripts",subscriptId,"navList"]);

    function onPlusMinusClicked(navUnitIndex){
        modelStore.dispatch(state=>{
            var subscript = access(state,["model","Script",scriptId,"subscripts",subscriptId]);
            if (subscript){
                var navUnit = subscript.navList[navUnitIndex];
                navUnit.isOpen = !navUnit.isOpen;
                subscript.navList = subscript.navList.splice(0);
            }
        });
    }

    var navigationRows = [];
    if (navUnits){
        var navUnitIndex = -1;

        var currentVisibleUpperLimit = 3;

        var navigationRows = [];
        $.each(navUnits,(u,uuu)=>{
            navUnitIndex++;
            uuu.index = navUnitIndex;
            if (uuu.level <= currentVisibleUpperLimit ) {
                navigationRows.push(<NavigationRow     
                    scriptId = {scriptId}
                    subscriptId = {subscriptId}
                    navUnit = {uuu}
                    key = {uuu.headBlockUid}
                    onSelectedNavigationChanged = {onSelectedNavigationChanged}
                    isOccupied = {navUnitIndex == occupiedNavUnitIndex}
                    navUnitIndex = {!navUnitIndex}
                    onPlusMinusClicked = {onPlusMinusClicked}  
                    levelShowing = {currentVisibleUpperLimit} 
                />);
                if (!uuu.isOpen){
                    currentVisibleUpperLimit = uuu.level;
                } else if (uuu.level <= currentVisibleUpperLimit){
                    currentVisibleUpperLimit = 3;
                }
            } else {
                if (uuu.level <= currentVisibleUpperLimit){
                    currentVisibleUpperLimit = 3;
                }
            }

        })
    }

    return (<TableColumn
        label = "navigation"
        key = "navigation"
        scriptId = {scriptId}
        subscriptId = {subscriptId}
        content = {navigationRows}
    />)

}

export function onNavLevel( scriptId , subscriptId ) {
    modelStore.dispatch(state=>{
        var subscript = access(state.model.Script,[scriptId,"subscripts",subscriptId]);
        if (subscript){
             var navLevel = subscript.navLevel?subscript.navLevel:3;
             subscript.navLevel = ((navLevel+1)%3)+1 ;// effectively decreasing by 1
             $.each(subscript.navList,(u,navUnit)=>{
                navUnit.isOpen = navUnit.level < subscript.navLevel
             })
             subscript.navList = subscript.navList.splice(0);
        }
    })
}